import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

// 路由数组，配置路由映射和组件映射关系  设置路由懒加载
const routes: Array<RouteRecordRaw> = [
  // 一级路由
  // 布局页面
  {
    path: "/",
    name: "Layout",
    // 路由懒加载：只有在这个路由被访问到的时候，才加载对应的组件
    component: () => import("../views/layout/layout.vue"),
    // 进入页面就自动跳转到首页    redirect
    // 可以使用redirect重定向，一进入主页就展示第一个子页面。redirect后面跟的是路径名
    redirect: "/product",
    // children 属性，也是数组对象，可以添加多个映射关系。里面是子路由，子路由里面的path不需要加 /
    children: [
      // 二级路由
      // 产品介绍
      {
        path: "product",
        name: "product",
        component: () => import("../views/product.vue"),
      },
      // 公司动态
      {
        path: "dynamics",
        name: "dynamics",
        component: () => import("../views/dynamics.vue"),
      },
      // 解决方案
      {
        path: "service",
        name: "service",
        component: () => import("../views/service.vue"),
      },
      // 关于我们
      {
        path: "about",
        name: "about",
        component: () => import("../views/AboutView.vue"),
      },
    ],
  },
  // --- 新增的一级路由：新闻详情页面 ---
  // 不放在 Layout 下，因此不会显示顶部菜单和 footer，占满全屏
  {
    path: "/news-detail/:id",
    name: "NewsDetail",
    component: () => import("../views/NewsDetail.vue"),
    meta: { title: "新闻详情" },
  },
  // --- 新增的一级路由：PDF 查看页面 ---
  // 使用 iframe 查看 pdf ✅
  {
    path: "/pdf-viewer", // 定义访问路径
    name: "PdfViewer", // 定义一个唯一的路由名称
    component: () => import("../views/PdfViewer.vue"),
    meta: { title: "产品pdf文档查看" }, // 为页面设置标题
  },
  //  使用插件查看 pdf,没成功❌
  {
    path: "/pdf-viewer-embed",
    name: "PdfViewerEmbed",
    component: () => import("../views/PdfViewerEmbed.vue"),
    meta: { title: "产品pdf文档查看" },
  },

  // 404页面一定要最后加载
  {
    // 使用正则表达式， catchAll就是获取到所有的。
    // 这个意思就是如果当前访问的路由当中找不到的话，它才会执行这个正则，并且跳转到404
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import("../views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // 路由配置
  routes,
});

// 前置导航守卫   next() 必不可少
// 在路由跳转之前进行判断
router.beforeEach((to, from, next) => {
  next();
});

export default router;
